import * as bip39 from "bip39"
import { WalletInfo } from "../WalletService";
import Web3 from "web3";
import { Network, Alchemy } from "alchemy-sdk";

const conf = require("../../conf.json");

export class WalletProvicer {
    /**
     * {
     *    key:String, // blockchain key
     *    text:String, // blockchain name
     *    url:String, // blockchain cluster url or name
     *    addressTip:String, //提示信息
     * }
     */
    blockchain = null;
    /**
     * @type {Alchemy}
     */
    alchemy = null;

    constructor(blockchain) {
        this.blockchain = blockchain
        const settings = {
            apiKey: conf.alchemy.key, // Replace with your Alchemy API Key.
            network: blockchain.network, // Replace with your network. Network.ETH_MAINNET
        };
        this.alchemy = new Alchemy(settings);
    }

    makeError(reason) {
        return { code: -1, reason: reason }
    }

    // /**
    //  * 获取指定ECR20代币的合约对象
    //  * @param {Token} token 
    //  */
    // contract(token) {
    //     let contract = this.#contracts[token.name];
    //     if (contract == null) {
    //         contract = new this.#web3.eth.Contract(this.#ECR20Abi, token.address);
    //     }
    //     return contract;
    // }

    // get ECR20Abi() {
    //     return this.#ECR20Abi;
    // }

    //need implement
    balanceOf(token, address) {
        return null;
    }

    //need implement
    subscribe() {
        return;
    }

    //need implement
    /**
     * 
     * @param {String} mnemonic 创建钱包使用的助记词
     * @returns {Promise<WalletInfo>}
     */
    importMnemonic(mnemonic) {
        return null;
    }
    makeNewMnemonic() {
        const mnemonic = bip39.generateMnemonic();
        return mnemonic;
    }

    /**
     * 判断钱包地址是否合法
     * @param {String} address 钱包地址
     */
    //need implement
    isValidAddress(address) {
        return false;
    }

    /**
     * 钱包被load出来以后调用
     * @param {WalletInfo} walletInfo 
     */
    onWalletLoaded(walletInfo) {
        return walletInfo;
    }

    /**
     * 根据gasPrice和gasUsed计算费用，不同的网络计算方式不同
     * @param {BigNumber} gasPrice 
     * @param {BigNumber} gasUsed 
     * @returns {bn:BigNumber, str:string}
     */
    calcGasFee(gasPrice, gasUsed) {
        return null;
    }

    async transfer(walletTxInfo) {

    }

    async transferToken(walletTxInfo) {

    }

    /**
     * 返回对应区块链网络的浏览地址
     * @param {"tx"|"address"} item 
     * @param {string} value 
     * @return {name,url}
     */
    getExplorer(item, value) {

    }

    /**
     * @returns {Web3}
     */
    getWeb3() {

    }

}